export interface GameweekLockMeta {
  status?: string | null;
  locksAt?: string | null;
}

export const isGameweekLocked = (meta: GameweekLockMeta): boolean => {
  const status = meta.status;
  if (
    status === 'locked' ||
    status === 'live' ||
    status === 'completed' ||
    status === 'finalised'
  ) {
    return true;
  }

  if (meta.locksAt) {
    return new Date() >= new Date(meta.locksAt);
  }

  return false;
};

export const useIsGameweekLocked = (meta: GameweekLockMeta): boolean => {
  return isGameweekLocked(meta);
};
